import React, {useEffect, useState} from 'react'
import SelectBox from './SelectBox';
import { formatFiscalDateFromString } from '../utils/commonUtils';
import { LineChart, ChevronRight } from 'lucide-react'
import Icon from '../utils/Icon';
import ExchangeIcon from '../utils/ExchangeIcon';

const toFiscalTerm = (fiscalDate, term) => {
    let formatedFiscalDate = formatFiscalDateFromString(fiscalDate, 'YYYY年m月期')
    if (term !== 'annual') {
        switch (term) {
            case '1q':
                formatedFiscalDate += ' 第1四半期';
                return formatedFiscalDate;
            case '2q':
                formatedFiscalDate += ' 第2四半期';
                return formatedFiscalDate;
            case '3q':
                formatedFiscalDate += ' 第3四半期';
                return formatedFiscalDate;
            case '4q':
                formatedFiscalDate += ' 第4四半期';
                return formatedFiscalDate;
        }
    }
    return formatedFiscalDate;
}

const TanshinTable = ({ tanshinData, period, onDashboardClick, selectedCompanies, onCompanyClick, addAllCompanies, addCompany, removeCompany, registeredCompanies }) => {
    const [hoveredSecCode, setHoveredSecCode] = useState(null);
    const [showSelectAllTooltip, setShowSelectAllTooltip] = useState(false);

    const onSelectAllClick = () => {
        const companies = tanshinData.map((company) => ({
            secCode: company.securities_code,
            companyName: company.company_name,
        }));
        addAllCompanies(companies);
    }

    const handleRegistCompany = (secCode, isRegistered) => {
        if (isRegistered) {
            removeCompany(secCode);
        } else {
            addCompany(secCode);
        }
    }

    const toTerm = (term) => {
        if (term == 'annual') {
            return "通期"
        } else if (term == '1q') {
            return "Q1";
        } else if (term == '2q') {
            return "Q2";
        } else if (term == '3q') {
            return "Q3";
        } else {
            return term
        }
    }

    return (
        <div id="earningsTableContainer" className="companies-table-container">
            <span id="earningsReportTitle"></span>
            
            {/* PC用テーブル - スマホでは非表示 */}
            <div className="table-margin hidden md:block">
                {showSelectAllTooltip && <div className="select-all-tooltip">すべて選択する</div>}
                <table id="earningsReportTable" className="companies-table w-full">
                    <thead>
                        <tr>
                            <th className="th-company-name top-left-radius-5">企業名</th>
                            <th className="th-industsry">業種</th>
                            <th className="th-date">日付</th>
                            <th className="th-fiscal-year-q">決算期</th>
                            <th className="th-graph-checkbox top-right-radius-5" onClick={onSelectAllClick} onMouseEnter={() => setShowSelectAllTooltip(true)} onMouseLeave={() => setShowSelectAllTooltip(false)}>
                                <LineChart />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tanshinData.map((company) => (
                            <tr key={company.doc_id}>
                                <td>
                                    <div className='flex'> 
                                        <div className='mr-2 flex items-center'>
                                            <div className='w-[25px] h-[25px] '>
                                                <Icon secCode={company.securities_code} companyImageUrl={company.image}/>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="dashboard-link py-2 mb-2" onClick={() => onDashboardClick(company.securities_code)}>{company.company_name}</div>
                                            <div className='flex'>
                                                <div className='ml-4'>({company.securities_code})</div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td className='td-industry'>{company.industry_name}</td>
                                <td>{company.date} {company.time && company.time.slice(0, 5)}</td>
                                <td>{company.fiscal_year_end ? toFiscalTerm(company.fiscal_year_end, company.term) : toTerm(company.term)}</td>
                                <td><SelectBox secCode={company.securities_code} companyName={company.company_name} selectedCompanies={selectedCompanies} onCompanyClick={onCompanyClick}/></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            
            {/* スマホ用カードビュー - PCでは非表示 */}
            <div className="md:hidden space-y-4 px-2">
                {tanshinData.map((company) => (
                    <div key={company.doc_id} className="border rounded-lg p-4 bg-white shadow-sm">
                        <div className="flex justify-between items-start mb-3">
                            <div className="flex items-start gap-2">
                                <div className="w-[25px] h-[25px] mt-1">
                                    <Icon secCode={company.securities_code} companyImageUrl={company.image}/>
                                </div>
                                <div>
                                    <div className="font-medium text-sm dashboard-link" onClick={() => onDashboardClick(company.securities_code)}>
                                        {company.company_name}
                                    </div>
                                    <div className="text-xs text-gray-500">({company.securities_code})</div>
                                </div>
                            </div>
                            <SelectBox 
                                secCode={company.securities_code} 
                                companyName={company.company_name} 
                                selectedCompanies={selectedCompanies} 
                                onCompanyClick={onCompanyClick}
                            />
                        </div>
                        
                        <div className="grid grid-cols-2 gap-2 text-xs text-gray-600 mt-3">
                            <div>
                                <span className="font-medium">日付:</span> {company.date} {company.time && company.time.slice(0, 5)}
                            </div>
                            <div>
                                <span className="font-medium">決算期:</span> {company.fiscal_year_end ? toFiscalTerm(company.fiscal_year_end, company.term) : toTerm(company.term)}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default TanshinTable